export default __webpack_public_path__ + "e5376bbfd7500affbe787d617eb0656d.svg";